import { render, staticRenderFns } from "./LiqPayMark.vue?vue&type=template&id=a1a53d10&scoped=true&"
import script from "./LiqPayMark.vue?vue&type=script&lang=js&"
export * from "./LiqPayMark.vue?vue&type=script&lang=js&"
import style0 from "./LiqPayMark.vue?vue&type=style&index=0&id=a1a53d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a53d10",
  null
  
)

export default component.exports